/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-attachment-sm': {
    width: 8,
    height: 12,
    viewBox: '0 0 8 12',
    data: '<path pid="0" d="M5.143 0c-.763 0-1.48.284-2.02.799-.54.515-.837 1.2-.837 1.928v4.91c0 .902.769 1.636 1.714 1.636s1.714-.734 1.714-1.637V4.804a.559.559 0 0 0-.571-.546.559.559 0 0 0-.572.546v2.832A.56.56 0 0 1 4 8.182a.56.56 0 0 1-.571-.546V2.727c0-.437.178-.848.502-1.157.324-.309.754-.48 1.212-.48.945 0 1.714.735 1.714 1.637v5.455c0 1.504-1.282 2.727-2.857 2.727-.763 0-1.48-.284-2.02-.799a2.649 2.649 0 0 1-.837-1.928V2.727a.559.559 0 0 0-.572-.545.559.559 0 0 0-.571.545v5.455c0 1.02.416 1.979 1.172 2.7A4.072 4.072 0 0 0 4 12c2.206 0 4-1.713 4-3.818V2.727C8 1.223 6.718 0 5.143 0z" _fill="#E25757"/>'
  }
})
